import { render, staticRenderFns } from "./BaseConfirmDialogExtended.vue?vue&type=template&id=79982b8e&scoped=true&"
import script from "./BaseConfirmDialogExtended.vue?vue&type=script&lang=js&"
export * from "./BaseConfirmDialogExtended.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfirmDialogExtended.vue?vue&type=style&index=0&id=79982b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79982b8e",
  null
  
)

export default component.exports